var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-xs"},[_c('p',{staticClass:"mb-xxxs mb-7",staticStyle:{"text-transform":"uppercase"}},[_vm._v(" "+_vm._s(_vm.fullName)+" - "+_vm._s(_vm.displayId)+" ")]),_c('h1',{staticClass:"header-title"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }